import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';

interface AuthenticationProps {
  readonly authenticated: boolean;
}

type Props = AuthenticationProps & RouteProps;

const PublicRoute: React.FC<Props> = ({ authenticated, location, ...props }: Props) => {
  if (authenticated) {
    const toRoute = {
      pathname: '/',
      state: { from: location },
    };

    return <Redirect to={toRoute} />;
  }

  return <Route {...props} />;
};

export default PublicRoute;
